export default class GalleryItem {
  id: string;

  entityId: string | undefined;

  entityTypeId: string | undefined;

  universeId: string | undefined;

  extension: string;

  thumbnailExtension: string;

  position: number;

  type: string;

  constructor(obj: any) {
    this.id = obj.id;
    this.entityId = obj.entityId;
    this.entityTypeId = obj.entityTypeId;
    this.universeId = obj.universeId;
    this.extension = obj.extension;
    this.thumbnailExtension = obj.thumbnailExtension;
    this.position = obj.position;
    this.type = obj.type;
  }

  getUrl(): string | undefined {
    return `${COW_USER_IMAGE_URL}/${this.id}.${this.extension}`;
  }
}
